// Scroll Gradient Component - applies fade gradient to scrollable element
class ScrollGradient {
  constructor(selector) {
    this.selector = selector;
    this.element = null;
    this.fadeDistance = 50; // Distance in px from bottom to start fading gradient
    this.initialized = false;

    // Check if element already exists
    this.element = document.querySelector(selector);

	if (this.element) {
      this.init();
    } else {
      // Wait for element to be added to DOM
      this.waitForElement();
    }
  }

  waitForElement() {
    // Use MutationObserver to watch for when the element is added
    const observer = new MutationObserver(() => {
      if (!this.element) {
        this.element = document.querySelector(this.selector);
        if (this.element) {
          observer.disconnect();
          this.init();
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  init() {
    if (this.initialized) return;
    this.initialized = true;

    this.element.classList.add('scroll-gradient-container');

    // Initial check for scrollable content
    this.updateGradientVisibility();

    // Listen to scroll events
    this.element.addEventListener('scroll', () => this.updateGradient());

    // Listen to resize events to recalculate
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => this.updateGradientVisibility(), 100);
    });
  }

  updateGradientVisibility() {
    const hasScrollableContent = this.element.scrollHeight > this.element.clientHeight;

    if (hasScrollableContent) {
      this.element.classList.add('scroll-gradient-active');
      this.updateGradient();
    } else {
      this.element.classList.remove('scroll-gradient-active');
    }
  }

  updateGradient() {
    const scrollTop = this.element.scrollTop;
    const scrollHeight = this.element.scrollHeight;
    const clientHeight = this.element.clientHeight;
    const scrollableDistance = scrollHeight - clientHeight;

    // Distance from bottom
    const distanceFromBottom = scrollableDistance - scrollTop;

    // Calculate opacity: 1 when far from bottom, 0 when at bottom
    let opacity = 1;
    if (distanceFromBottom < this.fadeDistance) {
      opacity = Math.max(0, distanceFromBottom / this.fadeDistance);
    }

    this.element.style.setProperty('--scroll-gradient-opacity', opacity);
  }
}

// Initialize the scroll gradient on the cart drawer
document.addEventListener('DOMContentLoaded', () => {
  new ScrollGradient('.f-cart-drawer .f-drawer__scroller');
});

// Also support manual initialization if needed
if (typeof window !== 'undefined') {
  window.ScrollGradient = ScrollGradient;
}
